import { render, staticRenderFns } from "./PDFViewerV3.vue?vue&type=template&id=4324bd28&scoped=true&"
import script from "./PDFViewerV3.vue?vue&type=script&lang=js&"
export * from "./PDFViewerV3.vue?vue&type=script&lang=js&"
import style0 from "./PDFViewerV3.vue?vue&type=style&index=0&id=4324bd28&scoped=true&lang=css&"
import style1 from "./PDFViewerV3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4324bd28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
